import React from 'react';
import Home from './pages/Home';
import './App.css';

const App = () => <Home />;

export default App;
